import { CurrentEnvironment } from '@src/shared/ui/components/CurrentEnvironment';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { motion } from 'framer-motion';
import React, { useRef } from 'react';

import { Header } from './sections/Header';
import { Main } from './sections/Main';

/**
 * Layout: Application
 *
 * Glues together the various pieces of the layout.
 *
 * @param children
 * @returns {Element}
 * @constructor
 */
export function Application({ children }) {
  const stickyRef = useRef(null);

  return (
    <ErrorHandler location="src/shared/ui/layouts/Application/Application.jsx">
      <motion.div
        animate="open"
        initial={{ opacity: 0 }}
        variants={{
          closed: { opacity: 0 },
          open: { opacity: 1 },
        }}
      >
        <div className="app-layout" ref={stickyRef} style={{ height: '100%', position: 'relative' }}>
          <CurrentEnvironment />
          <Header stickyRef={stickyRef} />
          <Main>{children}</Main>
        </div>
      </motion.div>
    </ErrorHandler>
  );
}
